import axios from 'axios';
export const AUTHENTICATION = process.env.VUE_APP_URLAUTHENTICATION;

export const Refresh = {
  getRefreshToken() {
    return axios.get(AUTHENTICATION + '/adm/refresh-token');
  },
};
